export const IFS_HOMEPAGE_URL = 'https://ifs-certification.com/';
